module.exports = __webpack_public_path__ + "static/section-img1-f3aa7a2d5110df6baaf5689d8154f678.png";